import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { ThemeProvider, useTheme } from './contexts/ThemeContext'
import { GastosProvider }       from './contexts/GastosContext'
import { MetasProvider }        from './contexts/MetasContext'
import { ProfileProvider }      from './contexts/ProfileContext'
import { PresupuestoProvider }  from './contexts/PresupuestoContext'
import BottomNav from './components/layout/BottomNav'
import FAB       from './components/ui/FAB'
import Login     from './components/screens/Login'
import Inicio    from './components/screens/Inicio'
import Registro  from './components/screens/Registro'
import Viajes    from './components/screens/Viajes'
import Resumen   from './components/screens/Resumen'
import Metas     from './components/screens/Metas'
import Perfil    from './components/screens/Perfil'
import Premium      from './components/screens/Premium'
import Presupuesto  from './components/screens/Presupuesto'
import { fonts } from './lib/themes'

function AppInner() {
  const { session, loading, isRecovery } = useAuth()
  const { theme } = useTheme()

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: theme.cream, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ fontFamily: fonts.script, fontSize: 22, color: theme.inkLight }}>cargando tu mundo</p>
      </div>
    )
  }

  if (!session || isRecovery) return <Login />

  return (
    <GastosProvider>
      <MetasProvider>
        <PresupuestoProvider>
        <ProfileProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div style={{ background: theme.cream, minHeight: '100vh' }}>
            <Routes>
              <Route path="/"         element={<Inicio   />} />
              <Route path="/registro" element={<Registro />} />
              <Route path="/viajes"   element={<Viajes   />} />
              <Route path="/resumen"  element={<Resumen  />} />
              <Route path="/metas"    element={<Metas    />} />
              <Route path="/perfil"   element={<Perfil   />} />
              <Route path="/premium"      element={<Premium      />} />
              <Route path="/presupuesto" element={<Presupuesto />} />
            </Routes>

            <FAB />
            <BottomNav />
          </div>
        </BrowserRouter>
        </ProfileProvider>
        </PresupuestoProvider>
      </MetasProvider>
    </GastosProvider>
  )
}

export default function App() {
  return (
    <ThemeProvider>
      <AppInner />
    </ThemeProvider>
  )
}
